import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Send Sendbird Batch Message
  [types.SEND_SENDBIRD_BATCH_MESSAGE_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.SEND_SENDBIRD_BATCH_MESSAGE_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.SEND_SENDBIRD_BATCH_MESSAGE_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.SEND_SENDBIRD_BATCH_MESSAGE_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

